export default __webpack_public_path__ + "static/media/add_payment_method.08022b2f.svg";